import { SpotlightTransition } from '@atlaskit/onboarding';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useState } from 'react';

import { FilterSpotlight } from './FilterSpotlight';
import { MoreActionsSpotlight } from './MoreActionsSpotlight';

export const HighImpactSpotlightTour = ({
	onDismiss,
}: {
	onDismiss: (isTourCompleted?: boolean) => void;
}) => {
	const { messageInstanceClicked } = useMessageInstanceEvent();
	const [activeSpotlight, setActiveSpotlight] = useState<null | number>(0);

	const next = () => {
		setActiveSpotlight((activeSpotlight || 0) + 1);
		void messageInstanceClicked({
			action: {
				actionType: 'open',
			},
			additionalMetadataFromFrontend: {},
			clickedElement: {
				buttonType: 'secondary',
				clickedElement: 'button',
				clickIdentifier: 'exploreActions',
			},
			messageEventType: 'clicked',
		});
	};

	const endTour = (isTourCompleted = false) => {
		setActiveSpotlight(null);
		onDismiss(isTourCompleted);
	};

	const renderActiveSpotlight = () => {
		const spotlights = [
			<FilterSpotlight key="filter-spotlight" onNext={next} onDismiss={endTour} />,
			<MoreActionsSpotlight key="more-actions-spotlight" onFinish={endTour} />,
		];

		if (activeSpotlight === null) {
			return null;
		}

		return spotlights[activeSpotlight];
	};

	if (activeSpotlight === null) {
		return null;
	}

	return <SpotlightTransition>{renderActiveSpotlight()}</SpotlightTransition>;
};
